import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=4a0ab41f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0ab41f"]])

export default __exports__